import { useEffect } from 'react';

const LiveChatWidget = () => {
  useEffect(() => {
    // Check if script already exists
    const existingScript = document.querySelector('script[data-widget-id="69aa47cfd72daa9e2ea99a04"]');
    if (existingScript) return;

    // Create and append the LeadConnector chat widget script
    const script = document.createElement('script');
    script.src = 'https://beta.leadconnectorhq.com/loader.js';
    script.setAttribute('data-resources-url', 'https://beta.leadconnectorhq.com/chat-widget/loader.js');
    script.setAttribute('data-widget-id', '69aa47cfd72daa9e2ea99a04');
    script.async = true;
    
    document.body.appendChild(script);

    return () => {
      // Cleanup on unmount (optional)
      // document.body.removeChild(script);
    };
  }, []);

  return null; // This component doesn't render anything
};

export default LiveChatWidget;
